// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BPpV","delete":"styles_delete__2gwxN","update":"styles_update__3Qg1O","add":"styles_add__HoR4U"};